import { useAppSelector } from '../../hooks/useStore'
import PublicAddPilgrim from '../PreReserve/PublicPreReserve/PublicAddPilgrim'
import PublicPilgrimsPreReserve from '../PreReserve/PublicPreReserve/PublicPilgrimsPreReserve'
import LoginForm from './LoginForm'
import RegisterForm from './RegisterForm'

const AuthPage = () => {
  const { authForm } = useAppSelector((state) => state.auth)

  switch (authForm) {
    case 'login':
      return <LoginForm />
    case 'register':
      return <RegisterForm />
    case 'publicPreReserve':
      return <PublicPilgrimsPreReserve />
    case 'publicPreReserveAddPilgrim':
      return <PublicAddPilgrim />
    default:
      return <LoginForm />
  }
}

export default AuthPage
